<script lang="ts">
    import {Flex, Spacer} from 'shared/layouts';
    import {getInjector} from 'src/core';
    import type {TextValueEditorOptions} from 'shared/value-editors/internal/editors/text/types';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {fly} from 'svelte/transition';
    import {exists} from 'shared/utils/custom-utils';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {getTextFromGridFieldValue} from 'src/features/erp-sutor/sutor-utils';
    import {EmployeeRecordDetailService} from './employee-record-detail.service';
    import {FOND_EMPLOYMENT_STATUS} from 'src/features/erp-sutor/sutor-fonds';
    import KpValueEditor from 'shared/value-editors/kp-value-editor/KpValueEditor.svelte';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let employmentRecord: RecordRow;

    const service = getInjector().getByClass(EmployeeRecordDetailService);

    const textNoteField = getFirstFieldByFieldTypeIdRecursive(employmentRecord, FOND_EMPLOYMENT_STATUS.textNoteFieldId);
    let textNoteValue = getTextFromGridFieldValue(textNoteField, '');

    let editing = false;
    let textValue = textNoteValue;

    function getAceEditorOptions(): TextValueEditorOptions {
        return {
            type: 'rich-textarea',
            aceOptions: {
                showPrintMargin: false
            }
        };
    }

    const handleEditClick = () => {
        editing = true;
    };

    const handleCancelEdit = () => {
        editing = false;
    };

    const handleUpdateTextNote = () => {
        const response = service.editEmploymentStatusTextNote(employmentRecord, textValue);

        if (!exists(response)) {
            editing = false;
            return;
        }

        const editedTextNoteField = getFirstFieldByFieldTypeIdRecursive(employmentRecord, FOND_EMPLOYMENT_STATUS.textNoteFieldId);
        textNoteValue = getTextFromGridFieldValue(editedTextNoteField, '');
        textValue = textNoteValue;

        editing = false;
    };
</script>

<Flex class="report-text-note-editor" direction="column" gap="xs">
    <Flex alignItems="center">
        {#if !editing}
            <KpIconButton buttonStyle="no-background" icon="edit" on:click={handleEditClick}/>
        {:else}
            <KpButton buttonStyle="danger" tooltipLabel="Zrušit" on:click={handleCancelEdit}>
                <IconedContent icon="cross-circle"/>
            </KpButton>

            <Spacer direction="horizontal" size="s"/>

            <KpButton buttonStyle="success" tooltipLabel="Uložit" on:click={handleUpdateTextNote}>
                <IconedContent icon="check-circle"/>
            </KpButton>
        {/if}
    </Flex>

    {#key editing}
        <div class="anim-container" in:fly={{y: 10, duration: 250}}>
            {#if !editing}
                {#if textValue}
                    <span class="text-note">{textNoteValue}</span>
                {:else}
                    <small class="text-muted">(nic zde není)</small>
                {/if}
            {:else}
                <KpValueEditor type="text"
                               options={getAceEditorOptions()}
                               bind:model={textValue}/>
            {/if}
        </div>
    {/key}
</Flex>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .text-note {
        white-space: pre-wrap;
        font-size: @font-size-large;
    }

    :global {
        .report-text-note-editor .ace-editor-wrapper {
            .ace-editor {
                height: 160px;
                min-height: 160px;
            }
        }
    }
</style>